import(/* webpackMode: "eager" */ "/builder/src/app/events/[slug]/EventPage.tsx")